import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { OrganizationTypes } from '@/common/constants';
import { Pagination } from '@/common/types';
import { API_URL, IOrganizationLiteDto } from '@/dtos';

export const MAX_SIZE = 50;

const QUERY_KEY = 'GET_ORGANIZATIONS_QUERY';


export interface Organization {
  id: string;
  name: string;
  children?: Organization[];
  path?: string;
  type?: OrganizationTypes;
}

const formatData = (organizations: IOrganizationLiteDto[]): Organization[] =>
  organizations.map((organization) => ({
    id: toString(organization.id || ''),
    name: organization.name || '',
  }));

interface Props {
  searchValue?: string;
  type?: OrganizationTypes;
  enabled: boolean;
  parentId?: string;
}

const useGetOrganizationQuery = (props: Props) => {
  const { searchValue, type, enabled, parentId } = props;
  const { isLoading, data } = useQuery(
    [QUERY_KEY, searchValue, type, parentId],
    () =>
      api.get<Pagination<IOrganizationLiteDto>>(API_URL.ORGANIZATIONS, {
        params: {
          statuses: 'ACTIVE',
          size: MAX_SIZE,
          type,
          ...(searchValue ? { search_value: searchValue } : {}),
          ...(parentId ? { parent_id: parentId } : {}),
        },
      }),
    { enabled }
  );

  return {
    organizations: formatData(data?.data?.content || []),
    // TODO: not clear total_elements or totalElements, need to clarify
    // @ts-ignore
    total: data?.data?.total_elements || data?.data?.totalElements || 0,
    isLoading,
  };
};

export default useGetOrganizationQuery;
